export default "__VITE_ASSET__C17zeaJS__"